<template>
  <div v-if="value" :class="{inline: 'inline'}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    if (this.value) this.startTimeout();
  },
  methods: {
    startTimeout() {
      if (typeof this.timeout === 'boolean' && this.timeout === false) return

      setTimeout(() => {
        this.$emit("input", false);
      }, this.timeout);
    },
  },
  watch: {
    value(now) {
      if (now === true) {
        this.startTimeout();
      }
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    timeout: {
      type: [Number, Boolean],
      default: 3000,
    },
    message: {
      type: String,
    },
    inline: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.inline {
  display: inline-block;
}
</style>